import { render, staticRenderFns } from "./ModalAddOrder.vue?vue&type=template&id=210396da&"
import script from "./ModalAddOrder.vue?vue&type=script&lang=js&"
export * from "./ModalAddOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports